import React from 'react';
import { FilterTwoTone } from '@ant-design/icons';

import Button, { ButtonProps } from './Button';

export type MoreButtonProps = Pick<
  ButtonProps,
  'disabled' | 'onClick' | 'comcode'
> & {
  to?: string;
};

const MoreButton = (props: MoreButtonProps) => {
  return (
    <Button
      icon={<FilterTwoTone twoToneColor="#eb2f96" />}
      type="dashed"
      {...props}
    />
  );
};

export default MoreButton;
